const server = (window.location.href.indexOf('myocg') >= 0) ? '' : 'http://216.250.115.251'
console.log('server: ' + server)
export default {
    server: server,
    imgserver: server + '/images'
}
